/**
 * Typ změny profilu
 */
export enum ProfileChangeType {
    /**
     * Přidání profilu
     */
    add = 1,
    /**
     * Aktualizace profilu
     */
    update = 2,
    /**
     * Odebrání profilu
     */
    remove = 3,
}
